import { render, staticRenderFns } from "./OutsideView.vue?vue&type=template&id=60b8f968&"
import script from "./OutsideView.vue?vue&type=script&lang=js&"
export * from "./OutsideView.vue?vue&type=script&lang=js&"
import style0 from "./OutsideView.vue?vue&type=style&index=0&id=60b8f968&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports